var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "order-items-table-row",
      class: {
        accepted: _vm.orderItemAccepted,
        declined: _vm.orderItemDeclined,
      },
    },
    [
      _c("div", { staticClass: "order-items-table-row-left" }, [
        _c("div", { staticClass: "single-order-card-label" }, [
          _vm._v("Item no:"),
        ]),
        _vm._v(" "),
        _c("div", [_vm._v(_vm._s(_vm.orderItemNumber))]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "row items-center no-wrap justify-between pr-2" },
          [
            _c("b-icon-exclamation", {
              staticClass: "mr-1",
              staticStyle: { width: "28px", height: "28px" },
              attrs: {
                id: `order-item-p-warn-${_vm.orderItem.id}`,
                variant: "danger",
              },
            }),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: `order-item-p-warn-${_vm.orderItem.id}`,
                  variant: "danger",
                },
              },
              [
                _vm._v(
                  "\n        " + _vm._s(_vm.itemPackagesDanger) + "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _vm.orderItem.product_id && !_vm.orderItem.is_declined
              ? _c(
                  "b-btn",
                  {
                    attrs: {
                      color: "info",
                      flat: "",
                      dense: "",
                      size: "xs",
                      "no-caps": "",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.showPackages = !_vm.showPackages
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.orderItem.packages.length
                            ? "Show Packages"
                            : "No Packages"
                        ) +
                        "\n        "
                    ),
                    _vm.showPackages
                      ? _c("b-icon-chevron-up")
                      : _c("b-icon-chevron-down"),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-items-table-row-product" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm.orderItem.image_url
              ? _c("b-img", {
                  staticClass: "order-items-table-row-product-image",
                  attrs: {
                    src: _vm.orderItem.image_url,
                    alt: _vm.orderItem.name,
                    "no-spinner": "",
                    width: "60px",
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", { staticClass: "order-items-table-row-product-name" }, [
                _vm._v(_vm._s(_vm.orderItem.name)),
              ]),
              _vm._v(" "),
              _vm.orderItem.category_type
                ? _c("div", [
                    _vm._v("\n          Product Line:\n          "),
                    _c("div", [
                      _vm._v(
                        "\n            " +
                          _vm._s(
                            _vm.orderItem.category_type
                              ? _vm.orderItem.category_type.name
                              : ""
                          ) +
                          " " +
                          _vm._s(
                            _vm.orderItem.category
                              ? _vm.orderItem.category.name
                              : ""
                          ) +
                          "\n          "
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.item.product_id
          ? _c("span", { staticClass: "mt-2 text-danger" }, [
              _vm._v("No Product"),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-items-table-row-brand" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.orderItem.brand ? _vm.orderItem.brand.name : "") +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-items-table-row-qty" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.getFormattedQty(
                _vm.orderItem.inventory_value,
                _vm.orderItem.inventory_unit
              )
            ) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-items-table-row-unit-price" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.getFormattedPrice(_vm.orderItem.unit_price)) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-items-table-row-total-price" }, [
        _vm._v(
          "\n    " +
            _vm._s(_vm.getFormattedPrice(_vm.orderItem.total_price)) +
            "\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "order-items-table-row-notes" },
        [
          _vm.orderItem.notes
            ? [
                _c("div", { staticClass: "single-order-card-label" }, [
                  _vm._v("Item Note:"),
                ]),
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.orderItemNotes) +
                    _vm._s(_vm.orderItemNotesHasMore ? "..." : "") +
                    "\n      "
                ),
                _vm.orderItemNotesHasMore
                  ? [
                      _c(
                        "a",
                        {
                          staticClass: "text-green no-decoration",
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.fullNotes = true
                            },
                          },
                        },
                        [_vm._v("More")]
                      ),
                    ]
                  : _vm._e(),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "order-items-table-row-actions" }, [
        _vm.orderItem.is_accepted
          ? _c("span", { staticClass: "text-primary" }, [_vm._v("ACCEPTED")])
          : _vm.orderItem.is_declined
          ? _c(
              "span",
              { staticClass: "text-negative" },
              [
                _vm._v("\n      DECLINED\n      "),
                _c("b-icon-info-circle-fill", {
                  staticStyle: { width: "26px", height: "26px" },
                  attrs: { id: "fees-info-icon", variant: "danger" },
                }),
                _vm._v(" "),
                _c("b-tooltip", { attrs: { target: "fees-info-icon" } }, [
                  _c(
                    "ul",
                    {
                      staticClass: "px-2 py-2 mb-0",
                      staticStyle: { "list-style-type": "none" },
                    },
                    _vm._l(_vm.declinedItemReasons, function (reason, key) {
                      return _c("li", { key: key }, [
                        reason.title
                          ? _c("div", [_vm._v(_vm._s(reason.title))])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", [_vm._v(_vm._s(reason.text))]),
                        _vm._v(" "),
                        _c("hr"),
                      ])
                    }),
                    0
                  ),
                ]),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "order-items-table-row-divider" }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showPackages,
              expression: "showPackages",
            },
          ],
          staticClass: "order-items-table-row-packages",
        },
        [
          _c("div", { staticClass: "packages-main" }, [
            _vm.orderItem.packages.length > 0
              ? _c("table", [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.orderItem.packages, function (itemPackage, key) {
                      return _c("tr", { key: key }, [
                        _c("td", [
                          _c(
                            "div",
                            { staticClass: "row items-center no-wrap" },
                            [_c("div", [_vm._v(_vm._s(itemPackage.tag))])]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("div", { staticClass: "pl-4" }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm.getFormattedQty(
                                    itemPackage.inventory_value,
                                    itemPackage.inventory_unit
                                  )
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("td"),
                        _vm._v(" "),
                        _c("td", { staticClass: "py-2" }, [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.getFormattedPrice(itemPackage.price))
                            ),
                          ]),
                        ]),
                      ])
                    }),
                    0
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "mt-4" }, [
              _c(
                "div",
                {
                  class: {
                    "text-negative":
                      _vm.orderItem.packages_qty !==
                      _vm.orderItem.inventory_value,
                  },
                },
                [
                  _c("span", { staticClass: "single-order-card-label mt-3" }, [
                    _vm._v("Package Quantity:"),
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.getFormattedQty(
                          _vm.orderItem.packages_qty,
                          _vm.orderItem.inventory_unit
                        )
                      ) +
                      "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  class: {
                    "text-negative":
                      _vm.orderItem.packages_price !==
                      _vm.orderItem.total_price,
                  },
                },
                [
                  _c("span", { staticClass: "single-order-card-label mt-3" }, [
                    _vm._v("Package Price:"),
                  ]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.getFormattedPrice(_vm.orderItem.packages_price)
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Source Package")]),
        _vm._v(" "),
        _c("th", { staticClass: "pl-4" }, [_vm._v("Qty")]),
        _vm._v(" "),
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Package Price")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }